import { Alert, Chip, Tooltip } from '@mui/material';

const obsoleteCategory = 'Obsolete';
const obsoleteMessage = 'This connector is obsolete. Choose a current connector for new connections.';

type ServiceConnectionObsoleteIndicatorProps = {
	categories?: readonly string[];
	variant?: 'badge' | 'warning';
};

export default function ServiceConnectionObsoleteIndicator({ categories, variant = 'badge' }: ServiceConnectionObsoleteIndicatorProps) {
	if (!categories?.includes(obsoleteCategory)) {
		return null;
	}

	if (variant === 'warning') {
		return <Alert severity="warning" sx={{ mb: 2 }}>{obsoleteMessage}</Alert>;
	}

	return (
		<Tooltip title={obsoleteMessage}>
			<Chip label="Obsolete" color="warning" size="small" sx={{ flexShrink: 0 }} />
		</Tooltip>
	);
}
